/** 与后端 Kb::SlugGenerator::FORMAT 对齐：小写字母、数字，段间单个连字符。 */
const PAGE_SLUG_FORMAT = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** 将用户输入规范为 url-safe slug 基名（无法规范时返回空串）。 */
export function normalizePageSlug(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** 是否为合法页面 slug。 */
export function isValidPageSlug(slug: string): boolean {
  return PAGE_SLUG_FORMAT.test(slug.trim());
}

/** @deprecated 默认 slug 已改为服务端随机串；保留供规范化展示。 */
export function slugifyPageTitle(title: string): string {
  return normalizePageSlug(title) || "entry";
}

/** 在已占用 slug 集合内生成唯一值（冲突时加 -2、-3…）。 */
export function uniquePageSlug(baseOrTitle: string, taken: Iterable<string>): string {
  const occupied = new Set(
    [...taken].map((slug) => slug.trim().toLowerCase()).filter(Boolean),
  );
  const base = normalizePageSlug(baseOrTitle) || "entry";
  if (!occupied.has(base)) return base;

  let n = 2;
  while (occupied.has(`${base}-${n}`)) n += 1;
  return `${base}-${n}`;
}
